import { useSelector } from 'react-redux';
import { isFeatureEnabled } from '../stores/features';

const useFeature = (name, variant = 'on') => {
  const features = useSelector(state => state.features);
  return isFeatureEnabled(features, name, variant);
};

export default useFeature;
